import { get } from 'axios';

export const downloadPDF = async (filename) => {
    
    try{
        const response = await get(`/downloads/${filename}.pdf`, {
            responseType: 'blob', // important
        }); 

        // if response status is not 200, move to catch block
        if(response.status !== 200) {
            throw new ApiHttpError(response);
        }

        if(navigator.msSaveOrOpenBlob){
            navigator.msSaveOrOpenBlob(response.data, `${filename}.pdf`);
        }else{
            //Build the blog PDF stream, write it to a link, and click it
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${filename}.pdf` ); //Filename passed as arg
            document.body.appendChild(link);
            link.click();
        }
        
    }catch({ response }) { 
        return {
            status: (response.status) ? response.status : 500,
            message: (response.data && response.data.message) ? response.data.message : 'Something went wrong. Please try again.'
        };
    }
      
};

/**
 * Error class that, when thrown, is able to pass a response
 * object to the catch block
 */
class ApiHttpError extends Error {
    constructor(response = { status: 500 }, ...params) {
        super(...params);

        this.response = response;
    }
}